module.exports = __webpack_public_path__ + "img/LiBeirut.aee7ff0a.jpeg";